const styles = ({ BREAKPOINTS }) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    padding: '70px 0 40px',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      padding: '40px 0'
    },
    '& input': {
      textAlign: 'center'
    }
  },
  logo: {
    display: 'inline-block',
    color: '#000',
    width: '76px',
    height: '42px',
    margin: '0 0 20px',
    '& svg': {
      display: 'inline-block',
      width: '100%',
      height: '100%'
    }
  },
  holder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  }
})

export default styles
